import React, { useState, useContext, useEffect } from 'react';
import { Input, message, Form, Tooltip, Row, Col } from "antd";
import { UserContext } from "../../App";
import Services from '../../network/Services';
import DeleteConfirmModal from "../DeleteConfirmModal";
import konsole from "../../network/konsole";
import EditModal from './EditModal';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { EditOutlined } from '@ant-design/icons';

const SearchByEmail = () => {
    const [selectedUserDetails, setSelectedUserDetails] = useState({});
    let lastSearchText = "";

    const [userList, setuserList] = useState();
    const [curMail, setCurMail] = useState('');
    const { setLoader } = useContext(UserContext);

    const [showDeleteModal , setShowDeleteModal] = useState(false)
    const [userDataToDelete , setUserDataToDelete] = useState()
    const [deleteModal , setDeleteModal] = useState(false)
    const [loggedInUserId, setloggedInUserId] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const [sortConfig, setSortConfig] = useState({ key: null, order: 'asc' });

    const handleSort = (key) => {
        setSortConfig(prev => ({
            key,
            order: prev.key === key && prev.order === 'asc' ? 'desc' : 'asc'
        }));
        setCurrentPage(1);
    };

    const sortIcon = (key) => {
        if (sortConfig.key !== key) return <FaSort style={{ color: '#aaa', marginLeft: '4px' }} />;
        return sortConfig.order === 'asc'
            ? <FaSortUp style={{ color: '#720c20', marginLeft: '4px' }} />
            : <FaSortDown style={{ color: '#720c20', marginLeft: '4px' }} />;
    };

    const getSortedData = (data) => {
        if (!sortConfig.key || !data) return data || [];
        return [...data]?.sort((a, b) => {
            let aVal = (a[sortConfig.key] || '').toString().toLowerCase();
            let bVal = (b[sortConfig.key] || '').toString().toLowerCase();
            if (aVal < bVal) return sortConfig.order === 'asc' ? -1 : 1;
            if (aVal > bVal) return sortConfig.order === 'asc' ? 1 : -1;
            return 0;
        });
    };

    const totalPages = (data) => Math.ceil((data?.length || 0) / pageSize);

    const paginatedData = (data) => {
        const start = (currentPage - 1) * pageSize;
        return (data || [])?.slice(start, start + pageSize);
    };

    const deleteData = (data) =>{
        konsole.log("Clicked", data)
        setUserDataToDelete(data)
        setShowDeleteModal(true)
    }

    const CallDeleteAPi = () =>{
        konsole.log("deleteModaldeleteModal",deleteModal)

        setLoader(true)

        let detetedBy = sessionStorage.getItem('loggedUserId')
        let promise = Services.deletePartnerUserDetails(userDataToDelete?.userId, userDataToDelete?.id, detetedBy)
        promise.then((response)=>{
          message.success("User Deleted Successfully")
          setShowDeleteModal(false)
          setDeleteModal(false)
          setuserList(userList.filter(data => { return data.userId !== userDataToDelete?.userId}));
          konsole.log("deletePartnerUserDetailsRes",response)
        }).catch((error)=>{
          konsole.log("deletePartnerUserDetailsError",error)
        }).finally(()=>{
          konsole.log("deletePartnerUserDetailsEnd")
          setLoader(false)
        })
    }

    useEffect(()=>{
        if(deleteModal == true){
            CallDeleteAPi()
        }
    },[deleteModal])

    useEffect(()=>{
        const _userId = sessionStorage.getItem('loggedUserId');
        setloggedInUserId(_userId);
    },[])

    const refreshData = ( needToUpdate ) => {
        if(needToUpdate) onSearch(lastSearchText);
        setSelectedUserDetails({});
    }

    const getPrimaryContactId = (data) => {
        for(let i=0; i<data.length; i++) if(data[i].contactTypeId === 1) return data[i].contactId;
        return null;
    }

    const editData = (data) => {
        setLoader(true);
        // getting contacts
        Services.getContactDetails(data.userId).then((res) => {
            data.primaryContactId = getPrimaryContactId(res.data.data?.contact?.mobiles);
            data.mobileNo = data.mobileNo?.replace(/\s|\-|\(|\)/g, "") // removing phone no. formating
            setSelectedUserDetails(data)
            konsole.log("kyu pcid", data.primaryContactId);
        }).catch((err) => {
            konsole.log("kyu err", err);
        }).finally(() => {
            konsole.log("kyu contactfetched", data);
            setLoader(false);
        })
    }

    const formatResults = (result) => {
        // formatting roles
        let roles = '';
        // let setOfRole = new Set(result.roleDetails.map(item => item.roleName)); // for removing duplicate entries
        result.roleDetails.forEach(role => {
            roles += role.roleName + ", ";
        });
        result.roleKey = roles.substring(0, roles.length - 2);

        // formatting createdON
        result.createdOn = result.createdOn ? formatDate(result.createdOn) : null;

        // formatting loginDate
        result.loginDate = result.loginDate ? formatDate(result.loginDate) : null;

        // formatting mobile no.
        result.mobileNo = result.mobileNo ? formatMobileNo(result.mobileNo) : null;

        return result;
    }

    const formatDate = (date) => {
        // YYYY-MM-DD to MM-DD-YYYY
        let resultDate = date.substring(0, 10).split('-');
        return resultDate[1]+"-"+resultDate[2]+"-"+resultDate[0];
    }

    const formatMobileNo = (mobileNo) => {
        let resultMobileNo = mobileNo;
        if(mobileNo?.length == 10 && mobileNo?.startsWith("+") == false) {
            mobileNo = "+1" + mobileNo;
        }
        if(mobileNo.substring(0,2) === "+1") { // US format +1 (xxx) xxx-xxxx
            resultMobileNo = mobileNo.substring(0, 2) + " (" + mobileNo.substring(2,5) + ") " + mobileNo.substring(5, 8) + "-" + mobileNo.substring(8);
        } else if(mobileNo.substring(0,3) === "+91") { // IN format +91 xxxxx-xxxxx
            resultMobileNo = mobileNo.substring(0,3) + " " + mobileNo.substring(3,8) + "-" + mobileNo.substring(8);
        }
        return resultMobileNo;
    }

    const onSearch = (value) => {
        let searchMail = value.length ? value : curMail;
        lastSearchText = searchMail;
        if(searchMail.length < 1) return;
        setLoader(true);
        Services.getUserByEmail(searchMail).then((res) => {
            let results = res.data.map(result => {return formatResults(result)});
            konsole.log(res, results)
            const roleUserId = sessionStorage.getItem('roleUserId')
            const allowedRoles = [11];
            if(roleUserId == 4){
                const filteredUsers = results?.filter(user => user?.roleDetails?.some(role => allowedRoles.includes(role.roleId)));
                setuserList(filteredUsers)
            }else{
                setuserList(results);
            }
        }).catch((err) => {
            setuserList([]);
            konsole.log("err", err);
        }).finally(()=>{
            konsole.log("Finish")
            setLoader(false)
        })
    };

    const handleHandOff = (userId) => {
        // userId = "962d83f2-b973-4f27-9524-xxxxxaxxxxxx"; // for safe in testing
        setLoader(true)
        Services.putClientHandOff(userId).then((res) => {
            konsole.log("ress", res)
            message.success("Hand off revoked successfully!");
        }).catch((err) =>  {
            konsole.log("err", err)
            message.warning("Something went wrong!");
        }).finally(() => {
            onSearch("")
            // setLoader(false)
        })
    }

    const isHandOffRevokePossible = (record) => {
        const isRoleValid = record?.roleDetails?.some(ele => ele.roleId == 1 || ele.roleId == 9 || ele.roleId == 10) == true;
        const isHandOff = record.isHandOff == true;

        return isRoleValid && isHandOff;
    }

    return (
        <>
        <EditModal selectedUserDetails={selectedUserDetails} refreshData={refreshData} />
        <div className="d-flex flex-column" style={{paddingTop: "12px"}}>
            <style>{`
              .kyu-search-input.ant-input,
              .kyu-search-input.ant-input:focus,
              .kyu-search-input.ant-input:hover,
              .kyu-search-input.ant-input-affix-wrapper,
              .kyu-search-input.ant-input-affix-wrapper:focus,
              .kyu-search-input.ant-input-affix-wrapper-focused {
                box-shadow: none !important;
                outline: none !important;
              }
            `}</style>
            <div className="select-container mt-1">
                <p className=" fs-5 mb-2" style={{marginTop:"5px"}}>
                Search your User by Email Address
                </p>
            </div>
            <Form onFinish={onSearch} >
                <Row className="">
                    <Col xs={24} lg={24} span={24} style={{ display: "flex", justifyContent: "space-between" }}>
                        <Col span={12} style={{ display: "flex" }}>
                            <div className=" d-flex mb-2" style={{justifyContent:"space-between",height:"44px"}}>
                                <Input
                                className="form-control fs-20 kyu-search-input"
                                style={{border:"none", width: "30rem", display: "flex", boxShadow: "none"}}
                                // type="email"
                                placeholder="Enter User Email Address Or User Name"
                                onChange={(e) => setCurMail(e.target.value)}
                                suffix={
                                <img onClick={onSearch} type="submit" style={{padding:"2px",height:"20px"}} src="/search icon.png" />}
                                />
                            </div>
                        </Col>
                    </Col>
                </Row>
            </Form>
            {
              showDeleteModal ? <DeleteConfirmModal visible={showDeleteModal} hideModal={setShowDeleteModal} titleText="Delete User" bodyContent="Do you want to delete this user?" deleteStatus={setDeleteModal} /> : ""
            }
            {userList ?
            (() => {
                const dtHeaderStyle = { color: '#333', fontWeight: 600, fontSize: '14px', background: '#fff', textAlign: 'start', padding: '8px' };
                const dtBodyStyle  = { color: '#333', fontSize: '13px', background: '', textAlign: 'start', fontWeight: 100, padding: '8px' };
                const dtBodyStyle2 = { color: '#333', fontSize: '13px', background: '', textAlign: 'center', fontWeight: 100, display: 'contents', padding: '8px' };

                const sortedData   = getSortedData(userList);
                const totalCount   = sortedData.length;
                const totalPgs     = totalPages(sortedData);
                const pageRows     = paginatedData(sortedData);

                const buildPageButtons = () => {
                    const pages = [];
                    for (let p = 1; p <= totalPgs; p++) {
                        if (p === 1 || p === totalPgs || (p >= currentPage - 1 && p <= currentPage + 1)) {
                            pages.push(p);
                        }
                    }
                    const result = [];
                    pages.forEach((p, i) => {
                        if (i > 0 && p - pages[i - 1] > 1) result.push('ellipsis-' + p);
                        result.push(p);
                    });
                    return result;
                };

                return (
                <div style={{ border: '1px solid #ddd', marginTop: '12px', display: 'flex', flexDirection: 'column' }}>
                    {/* Table */}
                    <div style={{ maxHeight: 'calc(100vh - 290px)', overflowY: 'auto' }}>
                        <table className="table table-bordered mb-0 staff-table custom-striped-table" style={{ fontFamily: 'Open Sans, sans-serif', fontSize: '13px' }}>
                            <thead style={{ position: 'sticky', top: -1, zIndex: 1, background: '#fff' }}>
                                <tr>
                                    <th style={dtHeaderStyle}>Subtenant</th>
                                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => { handleSort('userFullName'); setCurrentPage(1); }}>
                                        Name {sortIcon('userFullName')}
                                    </th>
                                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => { handleSort('emailId'); setCurrentPage(1); }}>
                                        Email {sortIcon('emailId')}
                                    </th>
                                    <th style={{ ...dtHeaderStyle, cursor: 'pointer' }} onClick={() => { handleSort('mobileNo'); setCurrentPage(1); }}>
                                        Phone No. {sortIcon('mobileNo')}
                                    </th>
                                    <th style={dtHeaderStyle}>Role</th>
                                    <th style={dtHeaderStyle}>Registered On</th>
                                    <th style={dtHeaderStyle}>Last Login Date</th>
                                    <th style={dtHeaderStyle}>Status</th>
                                    <th style={dtHeaderStyle}>Action</th>
                                    {/* <th style={dtHeaderStyle}>Hand Off</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {pageRows.length > 0 ? pageRows.map((record) => {
                                    const _isHandOffRevokePossible = isHandOffRevokePossible(record);
                                    return (
                                        <tr key={record.userId}>
                                            {/* Subtenant */}
                                            <td style={dtBodyStyle}>{record.subtenantName || '-'}</td>

                                            {/* Name */}
                                            <Tooltip title="Click here to edit user details">
                                                <td style={dtBodyStyle}>
                                                    <span style={{ color: '#333', fontWeight: 500, cursor: 'pointer' }} onClick={() => editData(record)}>
                                                        {record.userFullName}
                                                    </span>
                                                </td>
                                            </Tooltip>

                                            {/* Email */}
                                            <td style={dtBodyStyle}>{record.emailId}</td>

                                            {/* Phone */}
                                            <td style={dtBodyStyle}>{record.mobileNo || '-'}</td>

                                            {/* Role */}
                                            <td style={dtBodyStyle2}>
                                                <Tooltip title={record.roleKey}>
                                                    <span style={dtBodyStyle}>
                                                        {record.roleKey
                                                            ? record.roleKey.split(',')?.slice(0, 2).join(', ') + (record.roleKey.split(',')?.length > 2 ? '...' : '')
                                                            : '-'}
                                                    </span>
                                                </Tooltip>
                                            </td>

                                            {/* Registered On */}
                                            <td style={dtBodyStyle}>{record.createdOn || '-'}</td>

                                            {/* Last Login Date */}
                                            <td style={dtBodyStyle}>
                                                {record.loginDate ? record.loginDate :
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', border: '1.5px solid #adb5bd', borderRadius: '6px', padding: '2px 10px', background: '#f1f3f5', color: '#495260', fontWeight: 500, fontSize: '12px', whiteSpace: 'nowrap' }}>
                                                        <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#495260', display: 'inline-block', flexShrink: 0 }} />
                                                        Inactive
                                                    </span>
                                                }
                                            </td>

                                            {/* Status */}
                                            <td style={dtBodyStyle}>
                                                {record.isEmailVerified && record.isActive ?
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', border: '1.5px solid #52c41a', borderRadius: '6px', padding: '2px 10px', background: '#F3F8F5', color: '#15803D', fontWeight: 500, fontSize: '12px', whiteSpace: 'nowrap' }}>
                                                        <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#15803D', display: 'inline-block', flexShrink: 0 }} />
                                                        Active
                                                    </span>
                                                    :
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', border: '1.5px solid #adb5bd', borderRadius: '6px', padding: '2px 10px', background: '#f1f3f5', color: '#495260', fontWeight: 500, fontSize: '12px', whiteSpace: 'nowrap' }}>
                                                        <span style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#495260', display: 'inline-block', flexShrink: 0 }} />
                                                        Inactive
                                                    </span>
                                                }
                                            </td>

                                            {/* Action */}
                                            <td style={dtBodyStyle2}>
                                                {loggedInUserId != record.userId && (
                                                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', gap: '8px' }}>
                                                        <Tooltip title="Edit user">
                                                            <EditOutlined style={{ color: '#4a90d9', fontSize: '16px', cursor: 'pointer', marginTop:"6px"  }} onClick={() => editData(record)} />
                                                        </Tooltip>
                                                        <Tooltip title="Delete user">
                                                            <img src="/icons/delete-Icon_Option.svg" style={{ width: '16px', height: '16px', cursor: 'pointer', verticalAlign: 'middle', marginTop:"7px" }} onClick={() => deleteData(record)} />
                                                        </Tooltip>
                                                    </div>
                                                )}
                                            </td>

                                            {/* Hand Off */}
                                            {/* <td style={{ ...dtBodyStyle, textAlign: 'center' }}>
                                                {loggedInUserId != record.userId && (
                                                    <div
                                                        className={_isHandOffRevokePossible != true ? 'disableDiv' : ''}
                                                        title={_isHandOffRevokePossible != true ? "Admin can't hand off" : undefined}
                                                        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                                                    >
                                                        <div className="form-check form-switch mb-0" style={{ paddingLeft: '2.5em' }}>
                                                            <input
                                                                className="form-check-input shadow-none"
                                                                style={{ opacity: '1', cursor: _isHandOffRevokePossible ? 'pointer' : 'not-allowed', width: '3em', height: '1.5em' }}
                                                                type="checkbox"
                                                                checked={record.isHandOff == true}
                                                                disabled={_isHandOffRevokePossible != true}
                                                                onChange={() => handleHandOff(record.userId)}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </td> */}
                                        </tr>
                                    );
                                }) :
                                    <tr><td colSpan={10} style={{ textAlign: 'center', padding: '20px', color: '#777' }}>No records found.</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px', borderTop: '1px solid #ddd', background: '#fff' }}>
                        <span style={{ fontSize: '13px', color: '#555' }}>
                            Showing {totalCount === 0 ? 0 : Math.min((currentPage - 1) * pageSize + 1, totalCount)} to {Math.min(currentPage * pageSize, totalCount)} of {totalCount} entries
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <button onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1}
                                style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', color: '#555' }}>‹</button>

                            {buildPageButtons().map((p) =>
                                String(p).startsWith('ellipsis')
                                    ? <span key={p} style={{ padding: '0 4px', fontSize: '13px' }}>...</span>
                                    : <button key={p} onClick={() => setCurrentPage(p)}
                                        style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: currentPage === p ? '#720c20' : '#fff', color: currentPage === p ? '#fff' : '#555', cursor: 'pointer', fontSize: '13px' }}>
                                        {p}
                                    </button>
                            )}

                            <button onClick={() => setCurrentPage(p => Math.min(p + 1, totalPgs))} disabled={currentPage === totalPgs || totalPgs === 0}
                                style={{ width: '28px', height: '28px', border: '1px solid #474747', borderRadius: '4px', background: '#fff', cursor: (currentPage === totalPgs || totalPgs === 0) ? 'not-allowed' : 'pointer', color: '#555' }}>›</button>
                        </div>
                    </div>
                </div>
                );
            })()
            :
            <div style={{display: 'flex', paddingLeft: '10px'}}>
                {/* <img style={{display: 'inline-block', width: '25px', height: '20px'}} src='/icons/arrowIcon.svg' />
                <p style={{color:"#474747"}}>Please use search bar to get your user details</p> */}
            </div>
            }
        </div>
        </>
    )
}

export default SearchByEmail;